<div *transloco="let t" [ngClass]="{'hidden': showGame}">
    <div class="text-white font-medium text-[16px] text-center px-5 pt-5">{{t('wantToGame')}}</div>
    <div class="px-10">
        <div (click)="showGame = true" class="font-bold border-white border-2 mt-4 w-fit mx-auto px-4 rounded-sm text-[20px] text-center text-white">{{t('startGame')}}</div>
    </div>
    
</div>
@if(showGame){<iframe class="h-[calc(100dvh-60px)] w-screen absolute top-0 left-0" src="./assets/games/cube.html"></iframe>}